@if (person()) {
    <app-card-table
        tableKey="personEditFoldersInOrganizationTable"
        [tableTitle]="'person.foldersInOrganization.labelMulti'"
        [items]="person()!.folders"
        [columns]="columns"
        translatePrefix="person.foldersInOrganization."
        [hideCheckboxes]="true"
    >
        <ng-template pTemplate="service" let-item="item">
            {{ item.service }}
        </ng-template>
        <ng-template pTemplate="typeOfService" let-item="item">
            {{ item.typeOfService }}
        </ng-template>
        <ng-template pTemplate="workplace" let-item="item">
            {{ item.workplace }}
        </ng-template>
    </app-card-table>

}
